import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuMultiSelectSearch } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectSearch';

export const SbSharedRefineMenuFilterStoneComponent = props => (
    <SbSharedRefineMenuMultiSelectSearch {...props} />
);

export const SbSharedRefineMenuFilterStone = createFragmentContainer(
    SbSharedRefineMenuFilterStoneComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuFilterStone_viewer on Viewer {
                ...SbSharedRefineMenuMultiSelectSearch_viewer
            }
        `,
        searchBrowse: graphql`
            fragment SbSharedRefineMenuFilterStone_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuMultiSelectSearch_searchBrowse
            }
        `,
    }
);
